<h1 class="text-4xl font-bold mobile:text-lg">{{ 'auth.lets_get_started' | transloco }}</h1>
<p class="mt-1 text-black mobile:text-sm">{{ 'auth.onboarding_step_4.choose_how_you_want_to_get_started' | transloco }}
</p>

<p class="text-black mobile:text-sm mt-[5vh]">{{ 'auth.onboarding_step_4.usage_question' | transloco }}</p>

<app-upload-show-choice [(selectedOption)]="selectedOption"
    (selectedOptionChange)="onSelectedOptionChange()"></app-upload-show-choice>

<div class="max-w-screen-sm w-full mt-8 mb-6">
    <app-primary-button buttonText="{{ 'shared.continue' | transloco }}" [isDisabled]="false"
        (buttonClick)="continueButtonClick()">
    </app-primary-button>
</div>

<p class="mt-[5vh] text-center text-sm text-gray-500 font-normal">{{ 'auth.onboarding_step_4.privacy.first_part' |
    transloco }}<a [href]="termsAndConditionsURL" class="text-primary hover:underline">{{
        'auth.onboarding_step_4.privacy.second_part' | transloco }}</a>{{ 'auth.onboarding_step_4.privacy.third_part' |
    transloco }}</p>